module.exports = __webpack_public_path__ + "static/media/R-IGZO LCD.c488f32b.png";